import React, {useEffect} from "react";
import { useState, useRef } from 'react';
import "./DataTable.css";
import {ModalForms} from "../modal-forms/ModalForms";
import useAxiosPrivate from "../../context/useAxiosPrivate";


// формируем таблицу с данными
export const DataTable = ({
                            getFactories,
                            factories,
                            currentFactoryData,
                            usersByFactoryId,
                            setUsersByFactoryId,
                            getCompanies,
                            getUsersByFactoryId,
                            userRole,
                            modalType,
                            setModalType,
                            companies,
                            currentFactory,
                            setCurrentFactory
}) => {
  const [rowData, setRowData] = useState([])
  const licenses = useRef(0)
  const userCount = useRef(0)
  const [localId, setLocalId] = useState('');
  const [userActivityData, setUserActivityData] = useState(null);
  const [startGetDataForMiniature, setStartGetDataForMiniature] = useState(false);
  const [loadTable, setLoadTable] = useState(false);
  const [addressVisibility, setAddressVisibility] = useState(localStorage.getItem('addressVisibility') === 'true');
  const [descriptionVisibility, setDescriptionVisibility] = useState(localStorage.getItem('descriptionVisibility') === 'true');
  const [typeFinishLicenseSort, setTypeFinishLicenseSort] = useState(localStorage.getItem('typeFinishLicenseSort') ?? "toUp");
  const [isFiltrationFinishLicensesActive, setIsFiltrationFinishLicensesActive] = useState(localStorage.getItem('isFiltrationFinishLicensesActive') === 'true');
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    if (Array.isArray(usersByFactoryId) && usersByFactoryId.length > 0 && Array.isArray(companies) && companies.length > 0) {
      getRowData();
    } else {
      licenses.current = 0;
      setLoadTable(false)
    }
  }, [usersByFactoryId]);


  useEffect(() => {
    localStorage.setItem('addressVisibility', addressVisibility.toString())

  }, [addressVisibility]);

  useEffect(() => {
    localStorage.setItem('descriptionVisibility', descriptionVisibility.toString())
  }, [descriptionVisibility]);

  useEffect(() => {
    localStorage.setItem('isFiltrationFinishLicensesActive', isFiltrationFinishLicensesActive.toString())
  }, [isFiltrationFinishLicensesActive]);

  useEffect(() => {
    localStorage.setItem('typeFinishLicenseSort', typeFinishLicenseSort.toString())
  }, [typeFinishLicenseSort]);


  // подготавливаем данные для каждой отдельной строки в таблице
  const getRowData = async () => {
    await new Promise((res) => {
      res(dataProcessing())
    })
      .then((res) => {
        setRowData(res)
        if (userCount.current > 0) {
          setLoadTable(false)
          setStartGetDataForMiniature(true);
        } else {
          setLoadTable(true)
        }
      })
      .catch(e => {
        alert(JSON.stringify(e.response.data.message));
      });
  }

  const createDate = (date1) => {
    if (!date1) {
      return "-"
    }
    let date = new Date(date1);
    return ((date.getDate() < 10) ? '0' + date.getDate() : date.getDate()) + '.'
      + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.'
      + date.getFullYear();
  }

  const checkFinishLicense = (date, numberDaysBeforeLicenseFinish = 14) => {
    let currentDate = new Date();
    let licenseFinishDate = new Date(date);
    let startOfTheEndOfLicense = new Date(licenseFinishDate).setDate(licenseFinishDate.getDate() - numberDaysBeforeLicenseFinish)

    if (currentDate > licenseFinishDate) {
      return "licenseExpired";
    }
    else if (currentDate > startOfTheEndOfLicense) {
      return "licenseIsFinishing";
    }
    return false;
  }

  const dataProcessing = () => {
    let tempIndex = -1;
    let result = [];
    let finishedLicense = 0;
    let userCountTemp = 0;

    usersByFactoryId.forEach((companyData, companyIndex) => {
      // сохраняем id компании и её название
      tempIndex++;
      const temp = companies.filter((item) => {
        return item.company === companyData.companyName
      })
      result[tempIndex] = {tableId: companyIndex + 1};
      result[tempIndex].organization = companyData.companyName;
      result[tempIndex].companyName = companyData.companyName;
      result[tempIndex].contactFullName = temp.length !== 0 && temp[0].contact;
      result[tempIndex].phoneNumber = temp.length !== 0 && temp[0].phone;

        // если у компании есть пользователи, то сохраняем их данные. Нет - пропускаем
        if (companyData.users !== null) {
          companyData.users.forEach((user, userIndex) => {
            tempIndex++;
            userCountTemp++;
            result[tempIndex] = {tableId:`${companyIndex + 1}.${userIndex + 1}`};
            result[tempIndex].organization = `${user.company}/\n${user.name}`;
            result[tempIndex].description = user.description;
            result[tempIndex].isOnline = user.onlineNow;
            result[tempIndex].lastVisit = user.online;
            result[tempIndex].startLicense = user.dateStartUtc;
            result[tempIndex].finishLicense = user.dateEndUtc;
            result[tempIndex].keyLicense = user.deviceToken;
            result[tempIndex].userId = user.id;
            result[tempIndex].userName = user.name;
            result[tempIndex].userCompany = user.company;
            result[tempIndex].userAddress = user.address;
            result[tempIndex].userPlatform = (user.platform === null ) ? String(user.platform) : user.platform;
            result[tempIndex].licenseState = checkFinishLicense(user.dateEndUtc);
            if (result[tempIndex].licenseState === 'licenseIsFinishing') {
              finishedLicense++
            }
          })
        }
      }
    )
    userCount.current = userCountTemp ;
    licenses.current = finishedLicense;
    return result;
  }

  useEffect(() => {
    if (startGetDataForMiniature) {
      setStartGetDataForMiniature(false);
      const tableData = []
      rowData.forEach((row) => {
        !Number.isInteger(row.tableId) && tableData.push({userId: row.userId, tableId: row.tableId})
      })

      Promise.allSettled(tableData.map(dataObject => axiosPrivate.get(`/UserAdministration/UserActivities/${dataObject.userId}`)))
        .then(res => {
          setStartGetDataForMiniature(false);
          prepareDataSet(res, tableData);
        })
        .catch(e => {
          alert(JSON.stringify(e.response.value));
          setUserActivityData({info: "Неполадки при загрузке данных"})
         setLoadTable(true)
        });
    }
  }, [startGetDataForMiniature]);


  const prepareDataSet = (promiseData, tableData) => {
    const prepDataSetResult = {};
    let currentMonth = new Date().getMonth();
    let currentYear = new Date().getFullYear();
    let referenceDate = null;

    if (currentMonth < 11) {
      referenceDate = new Date(currentYear - 1, currentMonth + 1, 1, 0, 0, 0, 0);
    } else {
      referenceDate = new Date(currentYear, 0, 1, 0, 0, 0, 0);
    }

    promiseData.forEach((userVisitData, index) => {
      let currentUserDatesArray = userVisitData.value.data.datesOnline;
      if (currentUserDatesArray.length > 0) {
        const sortedDates = currentUserDatesArray.sort((a, b) => new Date(a) - new Date(b));
        const periodDates = sortedDates.filter((currentArrayDate) => {
          return new Date(currentArrayDate) >= referenceDate;
        })

        let user =  tableData[index].tableId
        prepDataSetResult[user] = {}
        prepDataSetResult[user].info = false;
        prepDataSetResult[user].months = [];
        let monthNumber = new Date(referenceDate).getMonth();
        for (let i = 0; i < 12; i++) {
          if (monthNumber > 11) {
            monthNumber = 0;
          }
          prepDataSetResult[user].months[i] = monthNumber;
          monthNumber++;
        }

        prepDataSetResult[user].months.forEach((monthIndex, index) => {
          prepDataSetResult[user][index] = periodDates.filter((date) => {
            return new Date(date).getMonth() === monthIndex;
          })
        })
      } else {
        let user = tableData[index].tableId
        prepDataSetResult[user] = {}
        prepDataSetResult[user].info = "Активности не было"
      }
    })
    setUserActivityData(prepDataSetResult)
    setLoadTable(true)
  }

  const Miniature = ({tableId, serverData}) => {
    const user = serverData[tableId]
    const arrayKeys = Object.keys(user).slice(0, 12);
    const Columns = () => {
      return arrayKeys.map((key) => {
        if (user[key].length > 0) {
          return <div className="graphic-column-wrapper" key={`dw${tableId}${key}`}>
                  <span key={`${tableId}${key}`}
                  className="graphic-miniature-column"
                  style={{
                      height: `${user[key].length * 100 / 31}%`,
                      }}>
                  </span>
              </div>
        }
        else {
          return <div className="graphic-column-wrapper" key={`dw${tableId}${key}`}>
                  <span key={`${tableId}${key}`}
                        style={{height: '0'}}
                  ></span>
          </div>
        }
      })
    }

    return (
      <>
        {
          user.info
          ? user.info
          : <div className="graphic-miniature-wrapper">
              <Columns />
          </div>
        }
      </>
    )
  }


  const filterFinishLicensesDates = (data)  => {
    if (typeFinishLicenseSort === "toUp") {
      return data.sort((a, b) => new Date(a.finishLicense) - new Date(b.finishLicense));
    }
    if (typeFinishLicenseSort === "toDown") {
      return data.sort((a, b) => new Date(b.finishLicense) - new Date(a.finishLicense));
    }

  }


  const setTableBody = () => {
    let data = null;
    if (isFiltrationFinishLicensesActive) {
      let copyRowData = rowData.filter((item) => {
        return !Number.isInteger(item.tableId);
      })
      data = filterFinishLicensesDates(copyRowData);
    } else {
      data = rowData;
    }

    return data.map((row, index) => {
      return <tr className="table-row" key={index + "_key"}>
        <td className="table-cell table-cell_text-black table-number">{row.tableId}</td>
        <td localid={index}
          style={userRole.roleId !== 1 ? {cursor: "auto", boxShadow: "none"} : {}}
          className={
          Number.isInteger(row.tableId)
            ? "table-cell table-cell_organization table-cell_text-black table-cell_text-bold table-organization"
            : "table-cell table-cell_text-black table-organization"
          }
           onClick={(event) => {
            if (userRole.roleId === 1) {
              setLocalId(event.currentTarget.getAttribute("localid"))
              Number.isInteger(row.tableId)
                ? setModalType('editCompany')
                : setModalType('editUser')
            }
          }}
          >{row.organization}
          {!Number.isInteger(row.tableId) && row.userPlatform !== "null" &&
            <div
              className={`platform platform__${row.userPlatform}`}
            ></div>
          }
        </td>
        <td
          style={Number.isInteger(row.tableId)  ? {border: "1x solid lightgrey", borderLeft: "none", borderRight: "none", backgroundColor: "#e3efef"} : {}}
          className={
            userRole.roleId === 1 && addressVisibility
              ? "table-cell table-cell_text-black table-description"
              : "table-cell table-cell_text-black table-description table-description_hidden"
          }

        >{row.userAddress}</td>
        <td
          style={Number.isInteger(row.tableId)  ? {border: "1x solid lightgrey", borderLeft: "none", borderRight: "none", backgroundColor: "#e3efef"} : {}}
          className={
            userRole.roleId === 1 && descriptionVisibility
            ? "table-cell table-cell_text-black table-description"
            : "table-cell table-cell_text-black table-description table-description_hidden"
        }

        >{row.description}</td>
        <td
          localid={index}
          className={
            Number.isInteger(row.tableId)
              ? "table-cell table-cell_organization"
              : "table-cell table-activity"
            }
          style={{padding: "0", height: "100px", textAlign: "center", fontSize: "1vw"}}
          onClick={(event) => {
            setLocalId(event.currentTarget.getAttribute("localid"))
          !Number.isInteger(row.tableId) && !userActivityData.info
            ? setModalType('activity')
            : setModalType('')
          }}
        >
          {
            !Number.isInteger(row.tableId) && <Miniature tableId={row.tableId} serverData={userActivityData}/>
          }
        </td>
        <td className={
          Number.isInteger(row.tableId)
          ? "table-cell table-cell_organization table-last-visit"
            : "table-cell table-last-visit"
        }>
          {
            !Number.isInteger(row.tableId) &&
            (row.isOnline === true
              ? <p style={{color: "#00b69b"}}>в сети</p>
              : <p style={{color : createDate(row.lastVisit) === "-" ? "red" : "inherit"}}>{createDate(row.lastVisit)}</p>)
          }
        </td>
        <td className={
          Number.isInteger(row.tableId)
            ? "table-cell table-cell_organization table-start-license"
            : "table-cell table-start-license"
        }>
          {
            !Number.isInteger(row.tableId) && createDate(row.startLicense)
          }
        </td>
        <td
          style={Number.isInteger(row.tableId)  ? {border: "1x solid lightgrey", borderLeft: "none", borderRight: "none", backgroundColor: "#e3efef"} : {}}
          className=
          {
            !Number.isInteger(row.tableId)
            ? row.licenseState === "licenseIsFinishing"
                ? "table-cell table-cell_back-lred table-finish-license"
                : row.licenseState === "licenseExpired" ? "table-cell table-cell_back-lgrey table-finish-license" : "table-cell table-finish-license"
            : null
          }
        >
          {
            !Number.isInteger(row.tableId) && createDate(row.finishLicense)
          }
        </td>
      </tr>
    })
  }

  const noData = () => {
    return <tr>
      <td
        style={{
          textAlign: "center",
          padding: "1vw",
          color: "black"
        }}
        className="table-cell"
        colSpan={
          descriptionVisibility && addressVisibility
            ? 8
            : descriptionVisibility || addressVisibility
              ? 7
              : 6
        }
      >
        Нет данных
      </td>
    </tr>
  }

  return (
    <>
      <table className="table">
        <thead className="table-header">
        <tr className="table-row">
          <th className="table-cell table-cell_back-lgrey table-number">№</th>
          <th className="table-cell table-cell_back-lgrey table-organization" style={{outline:"none", boxShadow: "none", cursor: "auto"}}
          >Организации
            <div className="buttons-show-columns">
              <button
                style={userRole.roleId !== 1 || addressVisibility ? {display: "none"} : {}}
                className="button-show-address" onClick={() => setAddressVisibility(!addressVisibility)}>
                {!addressVisibility && '>'}
              </button>
              <button
                style={userRole.roleId !== 1 || descriptionVisibility ? {display: "none"} : {}}
                className="button-show-description" onClick={() => setDescriptionVisibility(!descriptionVisibility)}>
                {!descriptionVisibility && '>'}
              </button>
            </div>
          </th>
          <th
            style={
              userRole.roleId !== 1
                ? {display: "none"}
                : descriptionVisibility // licenses.current
                  ? {width: "10%", position: "relative"} // when open both 'address' and 'description' columns
                  : {position: "relative", maxWidth: "20%"}
            }
            className={
              addressVisibility
                ? "table-cell table-cell_back-lgrey table-description"
                : "table-cell table-cell_back-lgrey table-description table-description_hidden"
            }
          ><button
            style={addressVisibility ? {} : {display: "none"}}
            className="button-hide" onClick={() => setAddressVisibility(!addressVisibility)}>
            {addressVisibility && '<' }
          </button>
            Адрес</th>
          <th
            style={
              userRole.roleId !== 1
                ? {display: "none"}
                : addressVisibility // licenses.current
                  ? {width: "10%", position: "relative"} // when open both 'address' and 'description' columns
                  : {position: "relative", maxWidth: "20%"}
            }
            className={
           descriptionVisibility
            ? "table-cell table-cell_back-lgrey table-description"
             : "table-cell table-cell_back-lgrey table-description table-description_hidden"
            }
          ><button
            // style={userRole.roleId !== 1 ? {display: "none"} : {}}
            style={descriptionVisibility ? {} : {display: "none"}}
            className="button-hide" onClick={() => setDescriptionVisibility(!descriptionVisibility)}>
            {descriptionVisibility && '<' }
          </button>
            Примечание</th>
          <th className="table-cell table-cell_back-lgrey table-activity" style={{outline:"none", boxShadow: "none", cursor: "auto"}}>Активность</th>
          <th className="table-cell table-cell_back-lgrey table-last-visit">Последний визит</th>
          <th className="table-cell table-cell_back-lgrey table-start-license">Начало лицензии</th>
          <th
            onClick={() => {
              setIsFiltrationFinishLicensesActive(!isFiltrationFinishLicensesActive);
              setLoadTable(true);
            }}
            style={licenses.current ? {width: "15%"} : {}}
            className={isFiltrationFinishLicensesActive ? "table-cell table-cell_back-lgrey-checked table-finish-license " : "table-cell table-cell_back-lgrey table-finish-license"}>
            <div style={{display: 'flex', justifyContent: "flex-start", alignItems: "center", rowGap: "10%", wordWrap: "normal"}}>
              <p style={licenses.current ? {width: "50%"} : {width: "100%"}}>Конец лицензии</p>
              <span
                style={licenses.current ? {margin: "0 auto"} : {display: "none"}}
                className="day-indicator table-cell_back-lred">
                {licenses.current}
            </span>
            </div>
            <div style={isFiltrationFinishLicensesActive ? {display: "flex", justifyContent: "center", alignItems: "center", columnGap: "5%", marginBottom: "0.5vw"} : {display: "none"}}>
              <button style={typeFinishLicenseSort === "toDown" ? {}: {backgroundColor: "#3cb7ff"}}
                className="filter-button"
                onClick={(event) => {
                  event.stopPropagation();
                  setTypeFinishLicenseSort("toUp");
                  setLoadTable(false);
                  setLoadTable(true);
              }}>&#x21c8;</button>
              <button style={typeFinishLicenseSort === "toUp" ? {}: {backgroundColor: "#3cb7ff"}}
                className="filter-button"
                onClick={(event) => {
                  event.stopPropagation();
                  setTypeFinishLicenseSort("toDown");
                  setLoadTable(false);
                  setLoadTable(true);
              }}>&#x21ca;</button>
            </div>
          </th>
        </tr>
        </thead>


        <tbody>
        {
          loadTable
          ? setTableBody()
          : noData()
        }
        </tbody>
      </table>

      {modalType && <ModalForms
        createDate={createDate}
        userActivityData={userActivityData}
        getFactories={getFactories}
        factories={factories}
        localId={localId}
        rowData={rowData}
        companies={companies}
        currentFactoryData={currentFactoryData}
        getCompanies={getCompanies}
        modalType={modalType}
        setModalType={setModalType}
        currentFactory={currentFactory}
        setCurrentFactory={setCurrentFactory}
        getUsersByFactoryId={getUsersByFactoryId}
        userRole={userRole}
      />}
    </>
  )
}